// extracted by mini-css-extract-plugin
module.exports = {"upsellItem":"pPXOQ","upsellItem-info":"pzDaV","upsellItem-info-image":"bXPls","upsellItem-info-title":"NCqEr","upsellItem-button":"j+FVx"};